pageId = 'reports-index'

$(document).on "pjaxload##{ pageId }", (e, $page, page) ->
  $reportsItems = $page.find('.reports-items')
  $('#nav-reports').addClass('active')
  renderToggleQuestions('unexpanded_questions')
  toggleQuestions($page, 'unexpanded_questions')
  translateReadableDay($page)
  $('#link-change-date').on 'click', tower.changeReportDate

  tower.scrollLoad $page, ->
    viewBy = $reportsItems.data('view-by')
    data = switch viewBy
      when 'member'
        {till_member_guid: $page.find('.member-report-item').last().data('guid')}
      when 'question'
        {till_question_guid: $page.find('.question-week').last().data('question-guid')}
      when 'timeline'
        {till_answer_guid: $page.find('.report-answer-item').last().data('guid')}

    $.ajax
      url: location.href
      data: data
      method: 'get'
      dataType: 'json'
    .done (data, status, xhr) ->
      if xhr.status != HTTP_STATUS_NO_CONTENT && data.html.trim().length > 0
        $items = $(data.html)
        tower.adjustReadableTime($items)
        $reportsItems.append $items
        renderToggleQuestions('unexpanded_questions')
        translateReadableDay($page)
        tower.initPermission()

toggleQuestions = ($page, key) ->
  $page.on 'click', '.link-toggle-question', (e) ->
    @dataset.expanded = !(@dataset.expanded == 'true')
    @parentNode.dataset.expanded = @dataset.expanded
    guids = $('.link-toggle-question[data-expanded="false"]').map(-> @dataset.questionGuid).get()
    simple.util.storage.set key, guids.join(',')

renderToggleQuestions = (key) ->
  return unless $('.link-toggle-question').length
  guids = simple.util.storage.get(key)
  return unless guids
  guids.split(',').forEach (guid) ->
    link = document.querySelector(".link-toggle-question[data-question-guid='#{guid}']")
    return unless link
    link.dataset.expanded = false
    link.parentNode.dataset.expanded = false

translateReadableDay = ($page) ->
  today = moment().startOf('day')

  $page.find('.date-delimiter').each (i, element) ->
    $element = $(element)
    date = moment($element.data('date'))
    if date.isSame(today, 'day')
      $element
        .find('.date').text('今')
      .end()
        .find('.day').remove()
    else if date.isSame(today.clone().subtract(1, 'd'), 'day')
      $element
        .find('.date').text('昨')
      .end()
        .find('.day').remove()
